const GET_RSU_INSTR_JOB_LIST = "GET_RSU_INSTR_JOB_LIST";
const GET_RSU_INSTR_STS_SUCCESS = "GET_RSU_INSTR_STS_SUCCESS";
const GET_RSU_INSTR_STS_FAILURE = "GET_RSU_INSTR_STS_FAILURE";
const GET_WORK_ORDER_STATUS = "GET_WORK_ORDER_STATUS";
const GET_WORK_ORDER_STATUS_SUCCESS = "GET_WORK_ORDER_STATUS_SUCCESS";
const GET_WORK_ORDER_STATUS_FAILURE = "GET_WORK_ORDER_STATUS_FAILURE";
const INSTALL_SUCCEEDED = "InstallSucceeded";
const SERVICE_MAX_UPDATE = "UpdateCompleted";
const RSU_STATES_FOR_SERVICEMAX_NOTIFICATION = "startFailed,DownloadFailed,DownloadCancelled,DownloadPaused,InstallPaused,InstallFailed,InstallSucceeded,InstallCancelled,HandledByFSE";

export {
    GET_RSU_INSTR_JOB_LIST,
    GET_RSU_INSTR_STS_SUCCESS,
    GET_RSU_INSTR_STS_FAILURE,
    GET_WORK_ORDER_STATUS,
    GET_WORK_ORDER_STATUS_SUCCESS,
    GET_WORK_ORDER_STATUS_FAILURE,
    INSTALL_SUCCEEDED,
    SERVICE_MAX_UPDATE,
    RSU_STATES_FOR_SERVICEMAX_NOTIFICATION
}